// src/pages/Welcome/LoadingState.jsx
import React from 'react';
import { welcomeStyles } from './styles';

const LoadingState = () => {
  return (
    <div style={welcomeStyles.loadingContainer}>
      <div style={welcomeStyles.loadingSpinner} />
      <p style={welcomeStyles.loadingText}>Discovering amazing deals for you...</p>
    </div>
  );
};

export default LoadingState;